module.exports = __webpack_public_path__ + "img/building.5d056868.svg";